import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import Tools from './pages/Tools';
import WorksheetGenerator from './pages/WorksheetGenerator';
import LineTracingWorksheet from './pages/LineTracingWorksheet';
import PrintHandwritingWorksheet from './pages/PrintHandwritingWorksheet';
import CursiveHandwritingWorksheet from './pages/CursiveHandwritingWorksheet';
import NameTracingWorksheet from './pages/NameTracingWorksheet';
import AlphabetTracingWorksheet from './pages/AlphabetTracingWorksheet';
import NumberTracingWorksheet from './pages/NumberTracingWorksheet';
import AIAnalysis from './pages/AIAnalysis';
import AnalysisView from './pages/AnalysisView';
import Pricing from './pages/Pricing';
import Dashboard from './pages/Dashboard';
import Settings from './pages/Settings';
import Login from './pages/Login';
import Register from './pages/Register';
import AdminDashboard from './pages/AdminDashboard';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="tools" element={<Tools />} />
        <Route path="tools/tracing-lines" element={<LineTracingWorksheet />} />
        <Route path="tools/print" element={<PrintHandwritingWorksheet />} />
        <Route path="tools/cursive" element={<CursiveHandwritingWorksheet />} />
        <Route path="tools/name-tracing" element={<NameTracingWorksheet />} />
        <Route path="tools/alphabet-tracing" element={<AlphabetTracingWorksheet />} />
        <Route path="tools/number-tracing" element={<NumberTracingWorksheet />} />
        <Route path="tools/:toolType" element={<WorksheetGenerator />} />
        <Route path="analysis" element={<AIAnalysis />} />
        <Route path="analysis/:publicId" element={<AnalysisView />} />
        <Route path="pricing" element={<Pricing />} />
        <Route path="login" element={<Login />} />
        <Route path="register" element={<Register />} />
        <Route
          path="dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="settings"
          element={
            <ProtectedRoute>
              <Settings />
            </ProtectedRoute>
          }
        />
        <Route
          path="admin"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
      </Route>
    </Routes>
  );
}

export default App;
